module.exports = __webpack_public_path__ + "static/media/Banner-Toodz-House.ead8c9d2.jpg";